import React from 'react';
import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchema from './stepsSchema';
import { DIET_TYPES_EN, DIET_TYPES_PT, DIET_MODES } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const activeLang = localStorage.getItem('i18nextLng');

const routes: Route[] = [
  {
    path: '/diet-settings/all/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={stepsSchema}
        currentMainStep="all"
        dietTypes={activeLang === 'pt-BR' ? DIET_TYPES_PT : DIET_TYPES_EN}
        dietModes={DIET_MODES}
      />
    ),
    private: true,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
